export default class UserRegister {
    constructor() {
        if (Electro.DEBUG) {
            console.info('UserRegister.constructor()');
        }

        this.loginForm = $('#loginform');
        this.consumerForm = $('#js-register-form');
        this.shelterForm = $('#js-shelter-register-form');

        this.init();
    }

    init() {
        if (this.loginForm.length > 0) {
            this.loginForm.on('submit', function () {
                const form = $(this);

                form.parsley().validate();

                if (form.parsley().isValid()) {
                    $('.js-btn--sign-in').addClass('disabled');
                }
            });
        }

        // Check for consumer form to prevent
        // Uncaught TypeError: Cannot read property 'on' of undefined
        if (this.consumerForm.length > 0) {
            const hash = window.localStorage.getItem('referrer_hash');
            if (hash) {
                const $referrer = $('<input type="hidden" name="referrer" />');
                $referrer.val(hash);
                this.consumerForm.append($referrer);
            }

            this.consumerForm.parsley();

            this.consumerForm.on('submit', function (e) {
                e.preventDefault();
                const form = $(this);

                form.parsley().validate();

                if (form.parsley().isValid()) {
                    $('.js-btn--join-now').addClass('disabled');
                }
            });

            this.consumerForm.find('input').on('change', () => {
                $('.ajax-error-register').html('');
            });
        }

        // Check for shelter form to prevent
        // Uncaught TypeError: Cannot read property 'on' of undefined
        if (this.shelterForm.length > 0) {
            // hide the join now button
            $('#js-shelter-register-form #join-now').hide();

            // Prevent submit on 'Enter' key from inputs to dsiable premature validation
            $('form input').on('keyup keypress', (e) => e.which !== 13);

            // hide the previous button until on section two
            $('#js-shelter-register-form #previous').hide();

            // Set up slider for shelter register
            const $slider = $('.js-registration-slider');
            $slider.slick({
                adaptiveHeight: true,
                arrows: false,
                draggable: false,
                infinite: false,
                swipe: false,
                touchMove: false,
            });

            this.checkTabindex();

            // Set up validation groups
            $('#js-shelter-register-form .slick-slide').each((index, section) => {
                $(section).find(':input').attr('data-parsley-group', `block${index}`);
            });

            // Next
            FreshStep.doc.on('click', '#next', () => {
                // Validate the current step before showing next step
                if (
                    $('#js-shelter-register-form')
                        .parsley()
                        .validate(`block${$slider.slick('slickCurrentSlide')}`)
                ) {
                    $($('.steps>div').get($slider.slick('slickCurrentSlide'))).addClass('complete');
                    $slider.slick('slickNext');
                    $('html, body').animate({ scrollTop: '0' }, 800);
                }
            });

            // Previous
            FreshStep.doc.on('click', '#previous', () => {
                $slider.slick('slickPrev');
                $('html, body').animate({ scrollTop: '0' }, 800);
            });

            // On after slide change
            $slider.on('afterChange', (event, slick, currentSlide, nextSlide) => {
                // if a user goes back to beginning, hide the previous button
                if (currentSlide === 0) {
                    $('#previous').hide();
                    $('#join-now').hide();
                }
                // show the previous button once you are on the second section
                else if (currentSlide === 1) {
                    // Replace next button if you went back
                    $('#join-now').hide();
                    $('#next').fadeIn('slow');
                    $('#previous').fadeIn('slow');
                }
                // Show submit button if you are on the last slide
                else if (currentSlide === 2) {
                    $('#next').hide();
                    $('#join-now').fadeIn('slow');
                }

                this.checkTabindex();

                // Update the progress
                $('.steps>div').removeClass('active');
                $($('.steps>div').get(currentSlide)).addClass('active');
            });

            // Set up parsley
            this.shelterForm.parsley().on('form:error', () => {
                // This global callback will be called for any field that fails validation.
                $('.slick-list').height($('.js-registration-slider .slick-current').height());
            });

            this.shelterForm.on('submit', function (e) {
                $(this).parsley().validate();

                if ($(this).parsley().isValid()) {
                    $('.js-btn--create-account').addClass('disabled');

                    return true;
                }

                e.preventDefault();

                return true;
            });

            this.shelterForm.find('input').on('change', () => {
                $('.ajax-error-register').html('');
            });
        }

        $(window).on('cloroxPreferenceCenterRegister', (e) => {
            if (Electro.DEBUG) {
                console.info('PC Register');
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'userRegister',
                register: 'true',
            });

            window.localStorage.removeItem('referrer_hash');
            const $form = $(e.target);
            const redirectTo = $form.find('input[name=redirect_to]').val();
            // Redirect to the location specified
            window.location = redirectTo;
        });

        $(window).on('cloroxPreferenceCenterLoginFailed', () => {
            $('.js-btn--sign-in').removeClass('disabled');
        });

        $(window).on('cloroxPreferenceCenterRegisterFailed', () => {
            $('.js-btn--join-now').removeClass('disabled');
            $('.js-btn--create-account').removeClass('disabled');
        });
    }

    checkTabindex() {
        const $this = this;

        $('.slick-slide textarea').attr('tabindex', '-1');

        $('.slick-slide.slick-current.slick-active textarea').attr('tabindex', '0');
    }
}
